import { useState, useEffect } from "react";
import { Leaf } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import ServiceCard from "../components/ServiceCard";
import { Skeleton } from "../components/ui/skeleton";

export default function Services() {
  const { t, L } = useApp();
  const [services, setServices] = useState(null);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([]));
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  const filtered = services === null ? [] :
    active === "all" ? services : services.filter((s) => s.category === active);

  return (
    <div>
      <div className="relative overflow-hidden bg-secondary/50 pt-32 sm:pt-40 pb-14 mb-10">
        <div className="absolute -top-10 end-16 h-64 w-64 rounded-full bg-accent/20 blur-3xl blob pointer-events-none" />
        <div className="absolute -bottom-20 start-16 h-64 w-64 rounded-full cb-gradient opacity-10 blur-3xl pointer-events-none" />
        <div className="relative text-center max-w-2xl mx-auto px-4">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-card/70 text-sm font-semibold text-primary mb-4"><Leaf className="h-4 w-4" /> Cloud Beauty</span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-foreground">{t.services.title}</h1>
          <p className="text-muted-foreground mt-3 text-lg">{t.services.subtitle}</p>
        </div>
      </div>
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">

        <div className="flex flex-wrap justify-center gap-2 mb-10" data-testid="category-filters">
          <button
            onClick={() => setActive("all")}
            data-testid="category-all"
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${
              active === "all" ? "bg-primary text-primary-foreground" : "bg-card cb-card-shadow text-foreground/70 hover:text-foreground"
            }`}
          >
            {t.services.all}
          </button>
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => setActive(c.id)}
              data-testid={`category-${c.id}`}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${
                active === c.id ? "bg-primary text-primary-foreground" : "bg-card cb-card-shadow text-foreground/70 hover:text-foreground"
              }`}
            >
              {L(c, "name")}
            </button>
          ))}
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 pb-8">
          {services === null
            ? Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-80 rounded-3xl" />)
            : filtered.length === 0
              ? <p className="col-span-full text-center text-muted-foreground py-16">{t.common.empty}</p>
              : filtered.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
        </div>
      </div>
    </div>
  );
}
